module.exports = __webpack_public_path__ + "static/media/welcome.ad41744b.png";